// extracted by css-extract-rspack-plugin
export default {"Video":"AutoPlayVideo-module__Video__lSOSO","PlayButton":"AutoPlayVideo-module__PlayButton__qBoHJ"};